import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Tooltip, Spin } from 'antd';
import {
    ScheduleOutlined
} from '@ant-design/icons';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { CollectionServer, errorCatch, GET, IfElse, POST, publish, QueryOrder, QueryParam, updateArrayInArray, useAuth } from 'fennec-ui';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

export default function NotifyBlock(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const { filters, compact, uuid } = props;
    const [readallspin, setReadallspin] = useState(false);
    const [spin, setSpin] = useState({});

    const date = (item) => {
        var time = dayjs(item.CreatedAt).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm');
        if (!item.prochitano) {
            return (
                <div style={{
                    color: "rgba(0, 0, 0, 0.65)",
                    fontSize: "12px", marginTop: "3px", fontWeight: "600", cursor: "pointer"
                }}>{time}</div>
            );
        } else {
            return (
                <div style={{
                    color: "rgba(0, 0, 0, 0.65)",
                    fontSize: "12px", marginTop: "3px"
                }}>{time}</div>
            );
        }
    };
    const action = (notify, document, { collection, setCollection }) => {
        setSpin({ ...spin, [notify.ID]: true })
        POST(auth, `/api/notify/read`, notify,
            ({ data }) => {
                if (data.notify) {
                    setCollection(updateArrayInArray(collection, data.notify))
                    publish(`service.notify.${uuid}`, [...data.notify])
                }
                setSpin({ ...spin, [notify.ID]: false });
            }, errorCatch);
    };
    const markAsReaded = (collection, setCollection) => {
        setReadallspin(true);
        var arr = collection.filter(s => !s.prochitano);
        if (arr.length > 0) {
            GET(auth, `/api/notify/read-all`,
                ({ data }) => {
                    setCollection([])
                    // publish(`service.notify.${uuid}`, [])
                    publish(`service.notify.clear`, [])
                    setReadallspin(false);
                }, errorCatch);
        }
    };
    const ui = (item, { collection, setCollection }) => {
        return (<div key={item.ID}>
            {compact && <div style={{ margin: "0px 5px 10px 5px", borderBottom: "1px solid #eee" }}>
                <Spin spinning={spin[item.ID] === true ? true : false}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div>
                            <div style={{ color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                            {item.prochitano && <div style={{ fontSize: "12px" }}>{item.tekstUvedomleniya}</div>}
                            {!item.prochitano && <div style={{ fontSize: "12px", fontWeight: "600", cursor: "pointer" }}
                                onClick={() => action(item, "read", { collection, setCollection })}
                            >{item.tekstUvedomleniya}</div>}
                        </div>
                    </div>
                </Spin>
            </div>
            }
            {!compact && <div key={item.ID} style={{ margin: "0px 10px", borderBottom: "1px solid #eee" }}>
                <Spin spinning={spin[item.ID] === true ? true : false}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ flexBasis: "85px", color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                        {item.prochitano && <div style={{ flexBasis: "100%" }}>{item.tekstUvedomleniya}</div>}
                        {!item.prochitano && <div style={{ flexBasis: "100%", fontWeight: "600", cursor: "pointer" }}
                            onClick={() => action(item, "read", { collection, setCollection })}
                        >{item.tekstUvedomleniya}</div>}
                    </div>
                </Spin>
            </div>}
        </div>
        );
    };
    return (
        <div style={{ backgroundColor: "white", borderRadius:"4px" }}>
            <div style={{ padding: (compact) ? "0px 10px" : "10px" }}>
                <CollectionServer
                    // onCollectionChange={(collection) => {
                    //     publish(`service.notify.${uuid}`, [...collection])
                    //     console.log("publish",`service.notify.${uuid}`);
                    // }}
                    subscribe={{
                        name: "service.notify",
                        filter: `service.notify.${uuid}`,
                        func: (data, { msg, collection, setCollection, setCollectionItem, removeCollectionItem, request, state }) => {
                            request()
                        }
                    }}
                    name={"InfrastrukturnieUvedomleniya"}
                    auth={auth}
                    size="small"
                    source={'/api/query/InfrastrukturnieUvedomleniya'}
                    contextFilters={() => [
                        QueryOrder("Prochitano", "ASC"),
                        QueryOrder("Data", "DESC"),
                        IfElse(compact, QueryParam("w-eqOrNu-Prochitano", "false"), undefined),
                        
                    ]}
                    filters={filters}
                    mode={"list"}
                    render={(item, idx, { collection, setCollection, setCollectionItem, update }) => {
                        return ui(item, { collection, setCollection })
                    }}
                    collectionActions={() => [{
                        mode: "func",
                        trigger: (click) => (
                            <Tooltip title="Прочитано">
                                <Button loading={readallspin} style={{ border: "none" }} size="small" onClick={click}><ScheduleOutlined /></Button>
                            </Tooltip>
                        ),
                        action: (values, unlock, close, { collection, setCollection }) => {
                            markAsReaded(collection, setCollection)
                        },
                    }]}
                />
            </div>
        </div>
    );
}
